import React from 'react';
import { StaggerContainer, StaggerItem } from '../ui/AnimatedSection';
import { useTenant } from '../../context/TenantContext';
import { MarketingSectionHeader } from './SectionHeader';

const DEFAULT_HEADING = 'In their *own* words';

export const Testimonials: React.FC = () => {
  const { tenant } = useTenant();
  const marketing = tenant?.branding.marketing;
  const testimonials = (marketing?.testimonials ?? []).filter(t => t.quote?.trim() && t.authorName?.trim());

  if (testimonials.length === 0) return null;

  const heading = marketing?.copy?.testimonialsHeading?.trim() || DEFAULT_HEADING;
  const subhead = marketing?.copy?.testimonialsSubhead?.trim();

  return (
    <section id="testimonials" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <MarketingSectionHeader
          marker="§ Voices"
          rubric="From recent students"
          headline={heading}
          subhead={subhead}
        />

        <StaggerContainer className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12 border-t-2 border-gray-900 pt-12">
          {testimonials.map((t, i) => (
            <StaggerItem key={i}>
              <article className="flex flex-col h-full">
                <p className="font-serif text-xl md:text-[1.4rem] leading-snug tracking-tight text-gray-900 mb-6 text-balance">
                  <span className="text-primary-600 italic mr-0.5">&ldquo;</span>
                  {t.quote}
                  <span className="text-primary-600 italic">&rdquo;</span>
                </p>
                <div className="mt-auto pt-4 border-t border-gray-300 flex items-center gap-3">
                  {t.authorImageUrl ? (
                    <img
                      src={t.authorImageUrl}
                      alt=""
                      loading="lazy"
                      className="w-9 h-9 rounded-full object-cover bg-gray-200"
                    />
                  ) : (
                    <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center text-primary-700 font-serif font-medium">
                      {t.authorName[0]}
                    </div>
                  )}
                  <div className="text-sm">
                    <div className="font-semibold text-gray-900">{t.authorName}</div>
                    {t.authorRole && (
                      <div className="font-mono text-[10px] uppercase tracking-wider text-gray-500 mt-0.5">
                        {t.authorRole}
                      </div>
                    )}
                  </div>
                </div>
              </article>
            </StaggerItem>
          ))}
        </StaggerContainer>
      </div>
    </section>
  );
};
